export default "__VITE_ASSET__DROncqHx__"